import { render, staticRenderFns } from "./ConsolidationOrdersTable.vue?vue&type=template&id=a56d47a8&scoped=true"
import script from "./ConsolidationOrdersTable.vue?vue&type=script&lang=js"
export * from "./ConsolidationOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationOrdersTable.vue?vue&type=style&index=0&id=a56d47a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56d47a8",
  null
  
)

export default component.exports